<template>
  <div class="calendar-date" :class="{'is-disabled' : past, 'is-today has-bg-lighter' : isToday}">
    <button class="date-item" @click="goToDayView('RDVS')">{{day}}<span v-if="day === '01'"> {{monthSmall}}</span></button>
    <div v-if="totalEvents <= 4" class="calendar-events">
      <transition-group enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" tag="div">
        <a @click="goToDayView('ACCESSES')" class="calendar-event is-size-6 is-warning" v-for="a in accesses" :key="a.pk">
          <span class="calendar-event-numero">1</span>
          <span class="calendar-event-label"><strong>Mandat:</strong>&nbsp;{{a.company_name}} - {{a.program_name}}</span>
        </a>
        <a @click="goToDayView('RDVS')" class="calendar-event is-size-6" v-for="r in rdvs" :key="r.pk" v-if="!r.canceled"
            :class="r.google_event_id ? 'has-bg-googleAgenda' : 'has-bg-rdv'">
          <span class="calendar-event-numero">1</span>
          <span class="calendar-event-label"><strong>{{r.rdv_type}}:</strong>&nbsp;{{r.contact_name}}</span>
        </a>
        <a @click="goToDayView('OPTIONS')" class="calendar-event is-size-6 has-bg-success" v-for="o in options" :key="o.pk">
          <span class="calendar-event-numero">1</span>
          <span class="calendar-event-label"><strong>Fin option:</strong>&nbsp;{{o.lot_ref}}</span>
        </a>
        <a @click="goToDayView('REMINDERS')" class="calendar-event is-size-6 has-bg-danger" v-for="r in reminders" :key="r.pk">
          <span class="calendar-event-numero">1</span>
          <span class="calendar-event-label"><strong>Rappel:</strong>&nbsp;{{r.title}}</span>
        </a>
        <a @click="goToDayView('USERS')" class="calendar-event is-size-6 has-bg-draft" v-for="u in users" :key="u.pk">
          <span class="calendar-event-numero">1</span>
          <span class="calendar-event-label"><strong>Fin de validité:</strong>&nbsp;{{u.first_name}} {{u.last_name}}</span>
        </a>
      </transition-group>
    </div>
    <div v-else class="calendar-events">
      <a @click="goToDayView('ACCESSES')" class="calendar-event is-size-6 has-bg-warning" v-if="accesses.length > 0">
        <span class="calendar-event-numero">{{accesses.length}}</span>
        <span class="calendar-event-label">Mandats arrivant à expiration</span>
      </a>
      <a @click="goToDayView('RDVS')" class="calendar-event is-size-6 is-rdv" v-if="rdvs.length > 0">
        <span class="calendar-event-numero">{{rdvs.length}}</span>
        <span class="calendar-event-label"><strong>Rendez-vous</strong></span>
      </a>
      <a @click="goToDayView('OPTIONS')" class="calendar-event is-size-6 has-bg-success" v-if="options.length > 0">
        <span class="calendar-event-numero">{{options.length}}</span>
        <span class="calendar-event-label"><strong>Options</strong>&nbsp;arrivant à expiration</span>
      </a>
      <a @click="goToDayView('REMINDERS')" class="calendar-event is-size-6 has-bg-danger" v-if="reminders.length > 0">
        <span class="calendar-event-numero">{{reminders.length}}</span>
        <span class="calendar-event-label"><strong>Rappels</strong></span>
      </a>
      <a @click="goToDayView('USERS')" class="calendar-event is-size-6 has-bg-draft" v-if="users.length > 0">
        <span class="calendar-event-numero">{{users.length}}</span>
        <span class="calendar-event-label">Documents en fin de validité</span>
      </a>
    </div>
  </div>
</template>

<script>
  import { CalendarDayMx } from '../../mixins'

  export default {
    name: 'CalendarDayItem',
    mixins: [CalendarDayMx],
    props: {
      myRdv: Boolean,
      filters: Object
    },
    data () {
      return {}
    },
    computed: {
    },
    methods: {
    }
  }
</script>

<style>
.calendar-event-numero {
  min-width: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/calendar/CalendarDayItem.vue